@let cart = this.cart();
@let term = this.term();
@let hideTerm = this.hideTerm();
<div class="tw-size-full">
  <div class="tw-flex tw-items-center tw-pb-2 tw-gap-2">
    <div class="tw-flex tw-items-center">
      @if (this.header(); as header) {
        <ng-container
          *ngTemplateOutlet="header; context: { total: total(), amountDue: amountDue() }"
        />
      } @else {
        <h2
          bitTypography="h4"
          id="purchase-summary-heading"
          class="!tw-m-0"
          data-testid="purchase-summary-heading-total"
        >
          {{ (appliedBalance() > 0 ? "amountDue" : "total") | i18n }}:
          {{ (appliedBalance() > 0 ? amountDue() : total()) | currency: "USD" : "symbol" }} USD
        </h2>
        <span bitTypography="h3">&nbsp;</span>
        @if (!hideTerm) {
          <span bitTypography="body1" class="tw-text-muted"> / {{ term }} </span>
        }
      }
    </div>
    <button
      type="button"
      size="small"
      (click)="toggleExpanded()"
      [bitIconButton]="isExpanded() ? 'bwi-angle-up' : 'bwi-angle-down'"
      [label]="
        isExpanded() ? ('Collapse purchase details' | i18n) : ('Expand purchase details' | i18n)
      "
      [attr.aria-expanded]="isExpanded()"
      [attr.aria-controls]="'purchase-summary-details'"
      data-testid="toggle-purchase-summary-details"
    ></button>

    @if (showDiscountBadges()) {
      @for (discount of cart.discounts; track $index) {
        <billing-discount-badge class="tw-mr-1" [discount]="discount"></billing-discount-badge>
      }
    }
  </div>

  @if (isExpanded()) {
    <div id="purchase-summary-details" class="tw-pb-2">
      <!-- Password Manager Section -->
      @if (
        cart.passwordManager.seats ||
        cart.passwordManager.additionalStorage ||
        cart.passwordManager.prorationCharges
      ) {
        <div id="password-manager" class="tw-border-b tw-border-secondary-100 tw-pb-2">
          <div class="tw-flex tw-justify-between tw-mb-1">
            <h3 bitTypography="h5" class="tw-text-muted tw-font-semibold">
              {{ "passwordManager" | i18n }}
            </h3>
          </div>

          <!-- Password Manager Members -->
          @if (cart.passwordManager.seats; as passwordManagerSeats) {
            <div id="password-manager-members" class="tw-flex tw-justify-between">
              <div class="tw-flex-1">
                <div bitTypography="body1" class="tw-text-muted tw-font-normal">
                  {{ passwordManagerSeats.quantity }}
                  {{
                    translateWithParams(
                      passwordManagerSeats.translationKey,
                      passwordManagerSeats.translationParams
                    )
                  }}
                  @if (!passwordManagerSeats.hideBreakdown) {
                    x
                    {{ passwordManagerSeats.cost | currency: "USD" : "symbol" }}
                    @if (!hideTerm) {
                      /
                      {{ term }}
                    }
                  }
                </div>
              </div>
              <div
                bitTypography="body1"
                class="tw-text-muted tw-font-normal"
                data-testid="password-manager-total"
              >
                {{ passwordManagerSeatsTotal() | currency: "USD" : "symbol" }}
              </div>
            </div>

            <!-- Password Manager Seats Discounts -->
            @for (discountRow of passwordManagerSeatsDiscountRows(); track $index) {
              @if (discountRow.amount > 0) {
                <div
                  class="tw-flex tw-justify-between"
                  data-testid="password-manager-seats-discount"
                >
                  <div
                    bitTypography="body1"
                    class="tw-pl-4 tw-text-success-600"
                    data-testid="password-manager-seats-discount-label"
                  >
                    {{ discountRow.label }}
                  </div>
                  <div
                    bitTypography="body1"
                    class="tw-text-success-600"
                    data-testid="password-manager-seats-discount-amount"
                  >
                    -{{ discountRow.amount | currency: "USD" : "symbol" }}
                  </div>
                </div>
              }
            }
          }

          <!-- Proration charges -->
          @for (prorationCharge of cart.passwordManager.prorationCharges; track $index) {
            <div class="tw-flex tw-justify-between" data-testid="password-manager-proration-charge">
              <div bitTypography="body1" class="tw-text-muted tw-font-normal">
                {{ translateWithParams(prorationCharge.translationKey) }}
              </div>
              <div
                bitTypography="body1"
                class="tw-text-muted tw-font-normal"
                data-testid="password-manager-proration-charge-total"
              >
                {{ prorationCharge.cost | currency: "USD" : "symbol" }}
              </div>
            </div>
          }

          <!-- Additional Storage -->
          @let additionalStorage = cart.passwordManager.additionalStorage;
          @if (additionalStorage) {
            <div id="additional-storage" class="tw-flex tw-justify-between">
              <div class="tw-flex-1">
                <div bitTypography="body1" class="tw-text-muted tw-font-normal">
                  {{ additionalStorage.quantity }}
                  {{
                    translateWithParams(
                      additionalStorage.translationKey,
                      additionalStorage.translationParams
                    )
                  }}
                  @if (!additionalStorage.hideBreakdown) {
                    x {{ additionalStorage.cost | currency: "USD" : "symbol" }}
                    @if (!hideTerm) {
                      /
                      {{ term }}
                    }
                  }
                </div>
              </div>
              <div
                bitTypography="body1"
                class="tw-text-muted tw-font-normal"
                data-testid="additional-storage-total"
              >
                {{ additionalStorageTotal() | currency: "USD" : "symbol" }}
              </div>
            </div>

            <!-- Additional Storage Discounts -->
            @for (discountRow of additionalStorageDiscountRows(); track $index) {
              @if (discountRow.amount > 0) {
                <div class="tw-flex tw-justify-between" data-testid="additional-storage-discount">
                  <div
                    bitTypography="body1"
                    class="tw-pl-4 tw-text-success-600"
                    data-testid="additional-storage-discount-label"
                  >
                    {{ discountRow.label }}
                  </div>
                  <div
                    bitTypography="body1"
                    class="tw-text-success-600"
                    data-testid="additional-storage-discount-amount"
                  >
                    -{{ discountRow.amount | currency: "USD" : "symbol" }}
                  </div>
                </div>
              }
            }
          }
        </div>
      }

      <!-- Secrets Manager Section -->
      @if (cart.secretsManager) {
        <div id="secrets-manager" class="tw-border-b tw-border-secondary-100 tw-py-2">
          <div class="tw-flex tw-justify-between">
            <div bitTypography="h5" class="tw-text-muted tw-font-semibold">
              {{ "secretsManager" | i18n }}
            </div>
          </div>

          <!-- Secrets Manager Members (absent when the preview's SM section has no seat line) -->
          @let secretsManagerSeats = cart.secretsManager.seats;
          @if (secretsManagerSeats) {
            <div id="secrets-manager-members" class="tw-flex tw-justify-between">
              <div bitTypography="body1" class="tw-text-muted tw-font-normal">
                {{ secretsManagerSeats.quantity }}
                {{
                  translateWithParams(
                    secretsManagerSeats.translationKey,
                    secretsManagerSeats.translationParams
                  )
                }}
                @if (!secretsManagerSeats.hideBreakdown) {
                  x
                  {{ secretsManagerSeats.cost | currency: "USD" : "symbol" }}
                  @if (!hideTerm) {
                    /
                    {{ term }}
                  }
                }
              </div>
              <div
                bitTypography="body1"
                class="tw-text-muted tw-font-normal"
                data-testid="secrets-manager-seats-total"
              >
                {{ secretsManagerSeatsTotal() | currency: "USD" : "symbol" }}
              </div>
            </div>

            <!-- Secrets Manager Seats Discounts -->
            @for (discountRow of secretsManagerSeatsDiscountRows(); track $index) {
              @if (discountRow.amount > 0) {
                <div
                  class="tw-flex tw-justify-between"
                  data-testid="secrets-manager-seats-discount"
                >
                  <div
                    bitTypography="body1"
                    class="tw-pl-4 tw-text-success-600"
                    data-testid="secrets-manager-seats-discount-label"
                  >
                    {{ discountRow.label }}
                  </div>
                  <div
                    bitTypography="body1"
                    class="tw-text-success-600"
                    data-testid="secrets-manager-seats-discount-amount"
                  >
                    -{{ discountRow.amount | currency: "USD" : "symbol" }}
                  </div>
                </div>
              }
            }
          }

          <!-- Additional Service Accounts -->
          @let additionalServiceAccounts = cart.secretsManager.additionalServiceAccounts;
          @if (additionalServiceAccounts) {
            <div id="additional-service-accounts" class="tw-flex tw-justify-between">
              <div bitTypography="body1" class="tw-text-muted tw-font-normal">
                {{ additionalServiceAccounts.quantity }}
                {{
                  translateWithParams(
                    additionalServiceAccounts.translationKey,
                    additionalServiceAccounts.translationParams
                  )
                }}
                @if (!additionalServiceAccounts.hideBreakdown) {
                  x
                  {{ additionalServiceAccounts.cost | currency: "USD" : "symbol" }}
                  @if (!hideTerm) {
                    /
                    {{ term }}
                  }
                }
              </div>
              <div
                bitTypography="body1"
                class="tw-text-muted"
                data-testid="additional-service-accounts-total"
              >
                {{ additionalServiceAccountsTotal() | currency: "USD" : "symbol" }}
              </div>
            </div>
          }

          <!-- Additional Service Accounts Discounts -->
          @for (discountRow of additionalServiceAccountsDiscountRows(); track $index) {
            @if (discountRow.amount > 0) {
              <div
                class="tw-flex tw-justify-between"
                data-testid="additional-service-accounts-discount"
              >
                <div
                  bitTypography="body1"
                  class="tw-pl-4 tw-text-success-600"
                  data-testid="additional-service-accounts-discount-label"
                >
                  {{ discountRow.label }}
                </div>
                <div
                  bitTypography="body1"
                  class="tw-text-success-600"
                  data-testid="additional-service-accounts-discount-amount"
                >
                  -{{ discountRow.amount | currency: "USD" : "symbol" }}
                </div>
              </div>
            }
          }

          <!-- Proration charges -->
          @for (prorationCharge of cart.secretsManager.prorationCharges; track $index) {
            <div class="tw-flex tw-justify-between" data-testid="secrets-manager-proration-charge">
              <div bitTypography="body1" class="tw-text-muted tw-font-normal">
                {{ translateWithParams(prorationCharge.translationKey) }}
              </div>
              <div
                bitTypography="body1"
                class="tw-text-muted tw-font-normal"
                data-testid="secrets-manager-proration-charge-total"
              >
                {{ prorationCharge.cost | currency: "USD" : "symbol" }}
              </div>
            </div>
          }
        </div>
      }

      @if (cart.privilegedControls) {
        <div id="privileged-controls" class="tw-border-b tw-border-secondary-100 tw-py-2">
          <div class="tw-flex tw-justify-between">
            <div bitTypography="h5" class="tw-text-muted tw-font-semibold">
              {{ "privilegedControls" | i18n }}
            </div>
          </div>

          @let privilegedControlsSeats = cart.privilegedControls.seats;
          @if (privilegedControlsSeats) {
            <div id="privileged-controls-members" class="tw-flex tw-justify-between">
              <div bitTypography="body1" class="tw-text-muted tw-font-normal">
                {{ privilegedControlsSeats.quantity }}
                {{
                  translateWithParams(
                    privilegedControlsSeats.translationKey,
                    privilegedControlsSeats.translationParams
                  )
                }}
                @if (!privilegedControlsSeats.hideBreakdown) {
                  x
                  {{ privilegedControlsSeats.cost | currency: "USD" : "symbol" }}
                  @if (!hideTerm) {
                    /
                    {{ term }}
                  }
                }
              </div>
              <div
                bitTypography="body1"
                class="tw-text-muted tw-font-normal"
                data-testid="privileged-controls-seats-total"
              >
                {{ privilegedControlsSeatsTotal() | currency: "USD" : "symbol" }}
              </div>
            </div>

            @for (discountRow of privilegedControlsSeatsDiscountRows(); track $index) {
              @if (discountRow.amount > 0) {
                <div
                  class="tw-flex tw-justify-between"
                  data-testid="privileged-controls-seats-discount"
                >
                  <div
                    bitTypography="body1"
                    class="tw-pl-4 tw-text-success-600"
                    data-testid="privileged-controls-seats-discount-label"
                  >
                    {{ discountRow.label }}
                  </div>
                  <div
                    bitTypography="body1"
                    class="tw-text-success-600"
                    data-testid="privileged-controls-seats-discount-amount"
                  >
                    -{{ discountRow.amount | currency: "USD" : "symbol" }}
                  </div>
                </div>
              }
            }
          }

          @for (prorationCharge of cart.privilegedControls.prorationCharges; track $index) {
            <div
              class="tw-flex tw-justify-between"
              data-testid="privileged-controls-proration-charge"
            >
              <div bitTypography="body1" class="tw-text-muted tw-font-normal">
                {{ translateWithParams(prorationCharge.translationKey) }}
              </div>
              <div
                bitTypography="body1"
                class="tw-text-muted tw-font-normal"
                data-testid="privileged-controls-proration-charge-total"
              >
                {{ prorationCharge.cost | currency: "USD" : "symbol" }}
              </div>
            </div>
          }
        </div>
      }

      <!-- Subtotal (rendered only when cart-level discounts are present) -->
      @if (hasCartDiscounts()) {
        <div
          id="subtotal-section"
          class="tw-flex tw-justify-between tw-pt-2"
          data-testid="subtotal-section"
        >
          <h3 bitTypography="h5" class="tw-text-muted tw-font-semibold">
            {{ "subtotal" | i18n }}
          </h3>
          <div bitTypography="body1" class="tw-text-muted" data-testid="subtotal-amount">
            {{ subtotal() | currency: "USD" : "symbol" }}
          </div>
        </div>
      }

      <!-- Discounts -->
      @for (discountItem of discountLineItems(); track $index) {
        @if (discountItem.amount > 0) {
          <div class="tw-flex tw-justify-between" data-testid="discount-section">
            <div bitTypography="body1" class="tw-text-success-600">{{ discountItem.label }}</div>
            <div bitTypography="body1" class="tw-text-success-600" data-testid="discount-amount">
              -{{ discountItem.amount | currency: "USD" : "symbol" }}
            </div>
          </div>
        }
      }

      <!-- Credit -->
      @if (creditAmount() > 0) {
        <div
          id="credit-section"
          class="tw-flex tw-justify-between"
          [class.tw-border-b]="!hasCartDiscounts()"
          [class.tw-border-secondary-100]="!hasCartDiscounts()"
          [class.tw-py-2]="!hasCartDiscounts()"
          data-testid="credit-section"
        >
          <div bitTypography="body1" class="tw-text-muted tw-font-normal">
            {{ translateWithParams(cart.credit!.translationKey, cart.credit!.translationParams) }}
          </div>
          <div
            bitTypography="body1"
            class="tw-text-muted tw-font-normal"
            data-testid="credit-amount"
          >
            -{{ creditAmount() | currency: "USD" : "symbol" }}
          </div>
        </div>
      }

      <!-- Estimated Tax -->
      <div
        id="estimated-tax-section"
        class="tw-flex tw-justify-between tw-border-b tw-border-secondary-100 tw-pb-0.5"
        [class.tw-pt-2]="!hasCartDiscounts()"
      >
        <h3 bitTypography="h5" class="tw-text-muted tw-font-semibold">
          {{ "estimatedTax" | i18n }}
        </h3>
        <div bitTypography="body1" class="tw-text-muted" data-testid="estimated-tax">
          {{ estimatedTax() | currency: "USD" : "symbol" }}
        </div>
      </div>

      <!-- Total -->
      <div id="total-section" class="tw-flex tw-justify-between tw-items-center tw-pt-2">
        <h3 bitTypography="h5" class="tw-text-muted tw-font-semibold">{{ "total" | i18n }}</h3>
        <div bitTypography="body1" class="tw-text-muted" data-testid="final-total">
          {{ total() | currency: "USD" : "symbol" }}
          @if (!hideTerm) {
            / {{ term }}
          }
        </div>
      </div>

      @if (appliedBalance() > 0) {
        <div id="applied-balance-section" class="tw-flex tw-justify-between tw-pt-2">
          <h3 bitTypography="h5" class="tw-text-muted tw-font-semibold">
            {{ "appliedBalance" | i18n }}
          </h3>
          <div bitTypography="body1" class="tw-text-muted" data-testid="applied-balance-amount">
            -{{ appliedBalance() | currency: "USD" : "symbol" }}
          </div>
        </div>
        <div id="amount-due-section" class="tw-flex tw-justify-between tw-items-center tw-pt-2">
          <h3 bitTypography="h5" class="tw-text-muted tw-font-semibold">
            {{ "amountDue" | i18n }}
          </h3>
          <div bitTypography="body1" class="tw-text-muted" data-testid="amount-due">
            {{ amountDue() | currency: "USD" : "symbol" }}
          </div>
        </div>
      }
    </div>
  }
</div>
